import React from 'react';
import l10n from "../l10n/localization";
import {Card, Col, Row} from "react-materialize";
import * as utils from "../utils/utils";
import Underwriters from "../components/prefTables/Underwriters";
import Vessels from "../components/prefTables/Vessels";
import Ports from "../components/prefTables/Ports";
import CWDrawer from "../components/drawer/CWDrawer";
import AuthRequiredComponent from "../components/common/AuthRequiredComponent";
import * as authHandler from "../utils/authHandler";
import * as routes from "../constants/routes";
import { history } from '../constants/common';
import Commodities from "../components/prefTables/Commodities";
import {API_ROUTE} from "../constants/ajaxRoutes";
import {directDownload, downloadDocument} from "../actions/documents";
import {connect} from "react-redux";

class Preferences extends AuthRequiredComponent {
    constructor(props) {
        super(props);

        this.state = {
            active: false,
            destroyer: null
        };
    }

    closeDrawer() {
        this.setState({active: false});
    }

    handleClick(component, item) {
        this.setState({active: false}, () => {
            this.setState({form: component, item: item, active: true})
        })
    }

    getBlocks() {
        return [
            {
                title: l10n.fog.underwriter,
                image: 'fa-life-ring',
                imageType: 'fa',
                component: Underwriters,
            },
            {
                title: l10n.fog.commodities,
                image: 'fa-archive',
                imageType: 'fa',
                component: Commodities
            },
            {
                title: l10n.common.menuPorts,
                image: 'fa-globe',
                imageType: 'fa',
                component: Ports
            },
            {
                title: l10n.fog.vessel,
                image: 'fa-ship',
                imageType: 'fa',
                component: Vessels,
            },
        ];
    }

    render() {
        if (!authHandler.isLoggedIn()) {
            history.push(routes.LOGIN);
        }

        return (
            <div>
                <Row className="with-max-width">
                    {!utils.notNullNorUndefined(this.state.component) && this.getBlocks().map((item, index) => {
                        return (
                            <Col s={12} m={6} l={3} className="pref-block" key={index}>
                                <Card onClick={() => /*this.setState({component: item.component})*/ this.handleClick(item.component, {title: item.title})}>
                                    {item.imageType === 'fa' &&
                                    <i className={'fa fa-2x ' + item.image}/>}
                                    <h2>{item.title}</h2>
                                </Card>
                            </Col>
                        )
                    })}
                    <Col s={12} m={6} l={3} className="pref-block">
                        <Card onClick={() => this.props.dispatch(directDownload(API_ROUTE + "/csv/export/fogs"))}>
                            <i className={'fa fa-2x fa-download'}/>
                            <h2>{l10n.fog.export_fogs}</h2>
                        </Card>
                    </Col>
                    <Col s={12} m={6} l={3} className="pref-block">
                        <Card onClick={() => this.props.dispatch(directDownload(API_ROUTE + "/csv/export/cargos"))}>
                            <i className={'fa fa-2x fa-download'}/>
                            <h2>{l10n.fog.export_cargos}</h2>
                        </Card>
                    </Col>
                    <Col s={12} m={6} l={3} className="pref-block">
                        <Card onClick={() => this.props.dispatch(directDownload(API_ROUTE + "/csv/export/affiliate-invoices"))}>
                            <i className={'fa fa-2x fa-download'}/>
                            <h2>{l10n.fog.export_affiliate_invoices}</h2>
                        </Card>
                    </Col>
                    <Col s={12} m={6} l={3} className="pref-block">
                        <Card onClick={() => this.props.dispatch(directDownload(API_ROUTE + "/csv/export/invoices"))}>
                            <i className={'fa fa-2x fa-download'}/>
                            <h2>{l10n.fog.export_invoices}</h2>
                        </Card>
                    </Col>
                </Row>

                {<CWDrawer {...this.props} outlet={this.state.form}
                           active={this.state.active}
                           depth={0}
                           item={this.state.item}
                           closeDrawer={() => this.closeDrawer()} />}
            </div>
        )
    }
}

export default connect()(Preferences);



// WEBPACK FOOTER //
// ./src/containers/Preferences.js